import AppModal from '@buncha/common/components/CustomModal/AppModal';
import React from 'react';
import {StyleSheet} from 'react-native';
import font from '@buncha/appStyles/style/font';
import {useColorThemeType} from '@buncha/appStyles/hooks/theme';

interface Props {
  open: boolean;
  onClose: () => void;
  askPermission: () => any;
}

const InitialLocationModal = (props: Props) => {
  const theme = useColorThemeType('main');
  return (
    <AppModal
      isOpen={props?.open}
      onClose={props?.onClose}
      topCTAHandelr={props.askPermission}
      hideBottomCta
      title={'Location Permissions'}
      subTitle="While on duty, your location is tracked and you can receive work assignments (tasks)."
      titleStyle={styles.headerTypo}
      ctaTopTitle={'Continue'}
      topCTAColor={theme?.background.green[100]}
    />
  );
};

export default React.memo(InitialLocationModal);

const styles = StyleSheet.create({
  headerTypo: {
    fontFamily: font.fonts['Mortise-Bold'],
    ...font.FontSize.fontH2,
  },
});
